const _UTILS = {
  ObserveIntersection(node, config, callback) {
    if (!node) callback(null);
    let observer = new IntersectionObserver((entries) => {
      callback(entries);
    }, config);

    observer.observe(node, config);
    return observer;
  },
  ObserveMutation(selector, options, callback) {
    let observer = new MutationObserver(callback);

    // Notify me of everything!
    let observerConfig = {
      attributes: true,
      childList: true,
      characterData: true,
    };
    observerConfig = Object.assign(observerConfig, options);

    // Node, config
    // In this case we'll listen to all changes to body and child nodes
    var targetNodes = document.querySelectorAll(selector);
    targetNodes.forEach((node) => {
      observer.observe(node, observerConfig);
    });
  },
};

document.addEventListener("alpine:init", () => {
  Alpine.data("HeaderNav", () => ({
    flags: {
      is_mobile: true,
      is_homepage: true,
    },
    init() {
      this.InitWatchers();
      this.InitSelf();
    },
    InitWatchers() {
      let am = this;
      am.$watch("flags.is_mobile", am.ToggleView.bind(am));
      document.addEventListener("headerStickyChange", am.ToggleView.bind(am));
    },
    InitSelf() {
      let am = this;
      am.flags.is_homepage = am.$el.dataset.ishomepage == "true";
      let mq = window.matchMedia("(max-width: 769px)");
      am.flags.is_mobile = mq.matches;
      mq.addEventListener("change", () => {
        am.flags.is_mobile = mq.matches;
      });
      am.ToggleView();
    },
    ToggleView() {
      let am = this;
      if (!am.flags.is_homepage) return;
      let $header = document.querySelector("#HeaderWrapper");
      if (am.flags.is_mobile) {
        $header.classList.toggle(
          "header-wrapper--overlay",
          !am.flags.is_mobile
        );
        $header.classList.toggle("is-light", !am.flags.is_mobile);
      } else {
        $header.classList.toggle(
          "header-wrapper--overlay",
          window.scrollY == 0
        );
        $header.classList.toggle("is-light", window.scrollY == 0);
      }
    },
    e_OpenMobileNav(e) {
      // console.log(e)
      document.dispatchEvent(new CustomEvent("mobileNav:open"));
    },
  }));

  Alpine.data("MobileNav", () => ({
    e_ToggleAccordions(e) {
      let $mobile_nav = e.target.closest("mobile-nav");
      let target_link = e.target.closest("details").dataset.link;
      $mobile_nav.querySelectorAll("details").forEach(($detail) => {
        if ($detail.dataset.link != target_link) {
          $detail.removeAttribute("open");
        }
      });
    },
  }));

  Alpine.data("MenuAccordion", () => ({
    flags: {
      is_mobile: true,
    },
    init() {
      this.InitWatchers();
      this.InitSelf();
    },
    InitWatchers() {
      let am = this;
      am.$watch("flags.is_mobile", am.ToggleView.bind(am));
    },
    InitSelf() {
      let am = this;
      let mq = window.matchMedia("(max-width: 767px)");
      am.flags.is_mobile = mq.matches;
      mq.addEventListener("change", () => {
        am.flags.is_mobile = mq.matches;
      });
      am.ToggleView();
    },
    ToggleView() {
      let am = this;
      if (!am.flags.is_mobile) {
        am.$el.setAttribute("open", true);
      } else {
        am.$el.removeAttribute("open");
      }
    },
  }));

  Alpine.data("VideoMp4", () => ({
    flags: {
      paused: true,
    },
    autoplay: false,
    loop: false,
    cache: {},
    init() {
      this.InitCache();
      this.InitSelf();
      this.InitEventHandlers();
    },
    InitSelf() {
      let am = this;
      am.cache.$video.poster = am.cache.$video.poster.replace("_small", "");
      if (am.autoplay) {
        am.cache.$video.play();
        am.flags.paused = false;
      }
      if (!am.autoplay) {
        am.cache.$video.removeAttribute("muted");
      }
      if (am.loop) {
        am.cache.$video.loop = true;
      }
      if (am.autoplay) {
        _UTILS.ObserveIntersection(am.cache.$video, {}, (entries) => {
          let entry = entries[0];
          am.cache.$video[entry.isIntersecting ? "play" : "pause"]();
        });
      }
    },
    InitCache() {
      let am = this;
      am.cache.$video = am.$el.querySelector("video");
      am.autoplay = am.$el.dataset.autoplay == "true";
      am.loop = am.$el.dataset.loop == "true";
    },
    InitEventHandlers() {
      let am = this;
      am.cache.$video.addEventListener("pause", () => {
        am.flags.paused = true;
      });
      am.cache.$video.addEventListener("play", () => {
        am.flags.paused = false;
      });
    },
    e_ToggleVideoPlay() {
      let am = this;
      am.flags.paused = !am.flags.paused;
      am.cache.$video.muted = false;
      am.cache.$video[am.flags.paused ? "pause" : "play"]();
      am.cache.$video.controls = !am.flags.paused;
      if (am.cache.$video.closest("#custom-video-card")) {
        am.cache.$video
          .closest("#custom-video-card")
          .classList.toggle("active");
      }
    },
  }));

  Alpine.data("Swiper", () => ({
    swiper: null,
    init() {
      this.InitSelf();
    },
    InitSelf() {
      let am = this;
      let sw_options = JSON.parse(am.$el.dataset.options);

      if (sw_options.centeredSlides) {
        let $slides = am.$el.querySelectorAll(".swiper-slide");
        if ($slides.length <= 3) {
          sw_options.initialSlide = 1;
        }
      }

      if (sw_options.pagination) {
        sw_options = Object.assign(sw_options, {
          pagination: {
            el: am.$el.querySelector(".swiper-pagination"),
            clickable: true,
          },
        });
      }

      if (sw_options.navigation) {
        sw_options = Object.assign(sw_options, {
          navigation: {
            nextEl: am.$el.querySelector(".swiper-button-next"),
            prevEl: am.$el.querySelector(".swiper-button-prev"),
          },
        });
      }

      sw_options.breakpoints = {
        768: {
          slidesPerView: sw_options.slidesPerViewTab,
          centeredSlides: sw_options.centeredSlidesTab,
          initialSlide: sw_options.initialSlideTab,
          spaceBetween: sw_options.spaceBetweenTab,
        },
        1024: {
          slidesPerView: sw_options.slidesPerViewDesk,
          centeredSlides: sw_options.centeredSlidesdesktop,
          spaceBetween: sw_options.spaceBetweenDesktop,
        },
      };

      am.swiper = new Swiper(am.$el, sw_options);
    },
  }));

  Alpine.data("ProductMain", () => ({
    price: "",
    price_modifier: "",
    percent_saved: "",
    flags: {
      is_Onetime: false,
    },
    init() {
      this.InitWatchers();
    },
    InitWatchers() {
      let am = this;
      am.$el.addEventListener("purchaseOption:changed", (e) => {
        // console.log(e);
        am.flags.is_Onetime = e.detail.is_Onetime;
        am.price = e.detail.price;
        am.price_modifier = e.detail.price_modifier;
        am.percent_saved = Math.floor((1 - am.price_modifier) * 100);
      });
    },
    GetPrice() {
      let am = this;
      return window.FormatMoney(am.price);
    },
    GetSubscriptionPrice() {
      let am = this;
      return window.FormatMoney(am.price * am.price_modifier);
    },
  }));

  Alpine.data("SubscriptionWidget", () => ({
    cache: {},
    price: "",
    price_modifier: "",
    purchaseOption: "",
    selling_plan: "",
    flags: {
      is_Onetime: false,
    },
    init() {
      this.InitWatchers();
      this.InitSelf();
      this.RemoveDefaultWidget();
    },
    InitWatchers() {
      let am = this;
      am.$watch("purchaseOption", () => {
        am.flags.is_Onetime = am.purchaseOption == "one-time";
        let e_detail = {
          is_Onetime: am.flags.is_Onetime,
          price: am.price,
          price_modifier: am.price_modifier,
        };
        am.cache.$product.dispatchEvent(
          new CustomEvent("purchaseOption:changed", { detail: e_detail })
        );
      });
    },
    InitSelf() {
      let am = this;
      am.purchaseOption = am.$el.dataset.preSelect;
      am.price = am.$el.dataset.price;
      am.price_modifier = am.$el.dataset.priceModifier;

      am.cache.$product = am.$el.closest(".page-content--product");
      am.cache.$product_form = am.$el.closest(".shopify-product-form");
    },
    RemoveDefaultWidget() {
      // remove recharge widget
      _UTILS.ObserveMutation(".shopify-product-form", {}, (m) => {
        // console.log(m);
        m.filter(
          (m_item) =>
            m_item.addedNodes.length &&
            m_item.addedNodes[0].classList.contains("rc_container_wrapper")
        ).forEach((m_item) => {
          m_item.addedNodes[0].remove();
        });
      });
    },
  }));

  Alpine.data("FAQs_WithImage", () => ({
    current: "",
    init() {
      this.InitSelf();
    },
    InitSelf() {
      let am = this;
      am.current = am.$el.dataset.current || "";
    },
    e_SetFaqCurrent(e, id) {
      let $button = e.target.closest(".collapsible-trigger");
      let am = this;
      am.current = id;
      if ($button.getAttribute("aria-expanded") == "false") {
        am.current = "";
      }
      // console.log($button, $button.getAttribute('aria-expanded'))

      // close any open collapsibles
      let $section = $button.closest("[x-data]");
      $section.querySelectorAll("at-collapsible").forEach(($tab) => {
        let $btn = $tab.querySelector("button");
        let $collapsible = $tab.querySelector(".collapsible-content");
        let tab_id = $collapsible.id;
        if (am.current != tab_id) {
          $btn.classList.remove("is-open");
          $collapsible.classList.remove("is-open");
          $collapsible.style.height = "0px";
        }
      });
    },
  }));

  document.addEventListener("rebuy.loaded", (event) => {
    console.log("rebuy.loaded");

    let $header = document.querySelector("#HeaderWrapper");
    $header.setAttribute("x-data", "HeaderNav");

    // trigger mobile menu on desktop
    // $header.querySelectorAll('.site-nav__link--has-dropdown').forEach(($nav_link) => {
    //   $nav_link.addEventListener('click', (e) => {
    //     // console.log(e);
    //     let is_navOpen = document.querySelector('html').classList.contains('mobile-nav-open');
    //     e.preventDefault();
    //     document.dispatchEvent(new CustomEvent(`mobileNav:${is_navOpen ? 'close' : 'open'}`));

    //     document.querySelectorAll('mobile-nav details').forEach(($detail) => {
    //       $detail.removeAttribute('open');
    //     });
    //     // open selected accordion menu
    //     let link = e.currentTarget.dataset.link;
    //     let $target = document.querySelector(`mobile-nav [data-link="${link}"]`);
    //     $target.setAttribute('open', '');
    //   });
    // });

    document
      .querySelector(".desktop-close-menu")
      .addEventListener("click", () => {
        document.dispatchEvent(new CustomEvent("mobileNav:close"));
      });
  });
});
